export enum SearchResultTypes {
  SEED = 'seed',
  BRAND = 'brand',
  PRODUCT = 'product',
  FAQ = 'faq',
  GANARBOL = 'ganarbol',
  GANAMIGO = 'ganamigo',
  GANACUATE = 'ganacuate'
}

export interface Seed {
  id: number;
  full_name: string;
  description: string;
  type: SearchResultTypes.SEED;
}

export interface Brand {
  category__id: number;
  id: number;
  name: string;
  type: SearchResultTypes.BRAND;
}

export interface Product {
  brand__category__id: number;
  brand__id: number;
  id: number;
  name: string;
  brand__name: string;
  type: SearchResultTypes.PRODUCT;
}

export interface Faq {
  answer: string;
  category__id: number;
  category__language__code: string;
  description: string;
  id: number;
  query: string;
  question: string;
  type: SearchResultTypes;
}

export interface Ganamigo {
  description: string;
  full_name: string;
  id: number;
  invited_user__id: number;
  type: SearchResultTypes.GANAMIGO;
}

export interface Ganarbol {
  description: string;
  full_name: string;
  id: number;
  invited_user__id: number;
  invited_user__public_id?: string;
  level__id: number;
  type: SearchResultTypes.GANARBOL;
}

export interface Ganacuate {
  description: string;
  full_name: string;
  id: number;
  invited_user__id: number;
  invited_user__public_id?: string;
  level__id: number;
  type: SearchResultTypes.GANACUATE;
}

export type SearchResult = Seed | Brand | Product | Faq | Ganamigo | Ganarbol | Ganacuate;

export interface IDirectReferralsResponse {
  count: number;
  counts: {
    my_ganacuates_count: number;
    my_ganarbols_count: number;
    my_ganasocios_count: number;
    total_direct_referrals: number;
  };
  links: any;
  per_page: number;
  results: any[];
  total_pages: number;
}
